import * as React from "react"
import parse from 'html-react-parser'

const GRMcontactForm = (props) => {
    const gitTrans = {
        'en': 'GET IN TOUCH',
        'es-co': 'PONERSE EN CONTACTO',
        'es-pe': 'PONERSE EN CONTACTO',
        'pt-br': 'ENTRAR EM CONTATO',
    }
    const reachTrans = {
        'en': 'You can reach out to us by phone at '+
            '<a href="tel:8889079687">888.907.9687</a>, '+
            'or fill out the form below',
        'es-co': 'Puede comunicarse con nosotros por teléfono al '+
            '<a href="tel:573003822177">+57 300 3822177</a>, '+
            'o complete el formulario a continuación',
        'es-pe': 'Puede comunicarse con nosotros por teléfono al '+
            '<a href="tel:013675009">01.367.5009</a>, '+
            'o complete el formulario a continuación',
        'pt-br': 'Você pode entrar em contato conosco por telefone '+
            '<a href="tel:552122231112">55.21.2223.1112</a>, '+
            'ou preencha o formulário abaixo',
    }
    const pardotSrc = {
        'en': 'https://info.grmdocumentmanagement.com/l/126821/2022-06-09/4jlmyz',
        'es-co': 'https://info.grmdocumentmanagement.com/l/126821/2023-04-03/4rqj89',
        'es-pe': 'https://info.grmdocumentmanagement.com/l/126821/2023-04-03/4rqj8h',
        'pt-br': 'https://info.grmdocumentmanagement.com/l/126821/2023-04-03/4rqj8d',
    }
    const fTitleTrans = {
        'en': 'GRM Document Management contact form',
        'es-co': 'Formulario de contacto de GRM Document Management',
        'es-pe': 'Formulario de contacto de GRM Document Management',
        'pt-br': 'Formulário de contato do GRM Document Management',
    }
    const langCode = props.langCode || 'en'
    const ctaText = props.ctaText || gitTrans[langCode]

    return (
        <>
        <div className="elementor-section elementor-section-boxed">
            <div className="elementor-container">
                <div id="contact-us" className="grm-pardot-form"
                        style={{ 
                            width: '100%',
                            textAlign: 'center',
                        }}>
                    <h2>{ctaText}</h2>
                    <p>{parse(reachTrans[langCode])}</p>
                    <iframe src={pardotSrc[langCode]} 
                        width="100%" 
                        height="520" 
                        type="text/html" 
                        allowtransparency="true"
                        title={fTitleTrans[langCode]}
                        style={{border: 0}}>
                    </iframe>
                </div>
            </div>
        </div>
        <style type="text/css" dangerouslySetInnerHTML={{
            __html: "#contact-us{margin-top:5rem}#contact-us,#contact-us .sub-footer-heading p{font-family:FuturaPT-Book,Helvetica,Arial,sans-serif;font-size:18px}#contact-us .sub-footer-heading p{line-height:23px;font-weight:400;color:#666;margin:24px 0 36px}#contact-us{padding:60px 0;position:relative}#contact-us:before{content:'';position:absolute;left:50%;top:0;width:100vw;z-index:-1;height:100%;background:#edf1f3;transform:translateX(-50%)}#contact-us h2{font-size:32px;color:#c41230;line-height:32px;font-family:FuturaPT-Bold,Helvetica,Arial,sans-serif;font-weight:600}#contact-us form>.wrap{display:flex;flex-flow:row wrap;margin:0 -15px}#contact-us .txtbox{margin-bottom:10px;padding:0 10px}"
        }} />
        </>
    )
}

export default GRMcontactForm;